import { defineMessages } from 'react-intl';

export default defineMessages({
  'dt:template_page_size:a4': {
    id: 'dt:template_page_size:a4',
    defaultMessage: 'A4',
  },
  'dt:template_page_size:letter': {
    id: 'dt:template_page_size:letter',
    defaultMessage: 'Letter',
  },
  'dt:template_page_size:legal': {
    id: 'dt:template_page_size:legal',
    defaultMessage: 'Legal',
  },
  'dt:template_page_size:receipt': {
    id: 'dt:template_page_size:receipt',
    defaultMessage: 'Receipt',
  },
  'dt:template_page_size:custom': {
    id: 'dt:template_page_size:custom',
    defaultMessage: 'Custom',
  },
});
